import { Link } from '@inertiajs/react';
import type { ArcadeInstance } from '@/types';

const TAB_BASE =
  'flex items-center gap-2 border-2 px-3 py-1.5 font-bold font-title text-sm uppercase tracking-wider transition-all md:text-base';

export function CityTabs({
  instances,
  activeSlug,
}: {
  instances: ArcadeInstance[];
  activeSlug: string;
}) {
  return (
    <nav
      aria-label="Arcade by hackathon"
      className="flex flex-wrap items-center justify-center gap-2 md:gap-3"
    >
      {instances.map((instance) => {
        if (!instance.enabled) {
          return (
            <span
              key={instance.slug}
              aria-disabled="true"
              title="coming soon"
              className={`${TAB_BASE} cursor-not-allowed border-primary/20 text-foreground/30`}
            >
              <span aria-hidden="true">{instance.flag}</span>
              {instance.label}
              <span className="font-mono text-[10px] text-foreground/40">
                soon
              </span>
            </span>
          );
        }

        const isActive = instance.slug === activeSlug;

        return (
          <Link
            key={instance.slug}
            href={`/26/arcade?event=${instance.slug}`}
            aria-current={isActive ? 'page' : undefined}
            className={`${TAB_BASE} ${
              isActive
                ? 'border-primary bg-primary text-background'
                : 'border-primary/40 text-primary hover:border-primary hover:bg-primary/10'
            }`}
          >
            <span aria-hidden="true">{instance.flag}</span>
            {instance.label}
          </Link>
        );
      })}
    </nav>
  );
}
